
  import {Component, Vue} from 'vue-property-decorator';

  @Component
  export default class IconHandler extends Vue {
  }
